// src/pages/CorporateHome.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function CorporateHome() {
  return (
    <div className="corporate-page">

      {/* HERO */}
      <section className="corp-hero text-light">
        <div className="corp-hero-overlay" />
        <div className="container h-100 d-flex align-items-center">
          <div className="corp-hero-content">
            <p className="corp-hero-kicker mb-2">
              GoShop • Marketplace & Logistique
            </p>
            <h1 className="corp-hero-title mb-3">
              Offrir plus de valeur, <br className="d-none d-md-block" />
              faire grandir nos partenaires.
            </h1>
            <p className="corp-hero-subtitle mb-4">
              GoShop connecte les vendeurs, les marques et les consommateurs
              en Afrique de l’Ouest grâce à un écosystème simple : 
              marketplace, logistique, paiement mobile.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <Link to="/catalog" className="btn btn-light fw-semibold">
                Découvrir les produits
              </Link>
              <Link
                to="/vendor/products"
                className="btn btn-outline-light fw-semibold"
              >
                Devenir vendeur partenaire
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION “À la une / Newsroom” */}
      <section className="corp-section py-5">
        <div className="container">
          <div className="d-flex justify-content-between align-items-baseline mb-3">
            <div>
              <h2 className="corp-section-title mb-1">
                Actualités & annonces
              </h2>
              <p className="text-muted small mb-0">
                Les dernières infos de GoShop, nos lancements et nos initiatives.
              </p>
            </div>
            <Link to="/news" className="small fw-semibold text-decoration-none">
              Voir tout&nbsp;›
            </Link>
          </div>

          <div className="row g-3 g-md-4">
            {/* Tu pourras plus tard rendre ces cartes dynamiques
                avec Firestore (collection “corporateNews” par ex.) */}
            <div className="col-md-4">
              <article className="corp-news-card card h-100 border-0 shadow-sm">
                <div className="corp-news-tag">Marketplace</div>
                <div className="card-body">
                  <h3 className="corp-news-title h6">
                    GoShop lance une nouvelle expérience d’achat
                    sans compte client.
                  </h3>
                  <p className="corp-news-meta text-muted small mb-2">
                    Oct. 2025 • Communiqué
                  </p>
                  <p className="corp-news-excerpt small text-muted mb-3">
                    Un parcours de commande simplifié, basé sur le paiement mobile
                    et WhatsApp, pour rendre l’e-commerce accessible à tous.
                  </p>
                  <Link to="/news" className="corp-news-link small">
                    Lire le communiqué
                  </Link>
                </div>
              </article>
            </div>

            <div className="col-md-4">
              <article className="corp-news-card card h-100 border-0 shadow-sm">
                <div className="corp-news-tag">Logistique</div>
                <div className="card-body">
                  <h3 className="corp-news-title h6">
                    Un nouveau service de livraison inter-villes.
                  </h3>
                  <p className="corp-news-meta text-muted small mb-2">
                    Sept. 2025 • Article
                  </p>
                  <p className="corp-news-excerpt small text-muted mb-3">
                    De Lomé à Cotonou, nos partenaires transport apportent plus
                    de flexibilité aux vendeurs et aux clients GoShop.
                  </p>
                  <Link to="/news" className="corp-news-link small">
                    En savoir plus
                  </Link>
                </div>
              </article>
            </div>

            <div className="col-md-4">
              <article className="corp-news-card card h-100 border-0 shadow-sm">
                <div className="corp-news-tag">Communauté</div>
                <div className="card-body">
                  <h3 className="corp-news-title h6">
                    Programme “Petits Commerçants, Grandes Ambitions”.
                  </h3>
                  <p className="corp-news-meta text-muted small mb-2">
                    Août 2025 • Story
                  </p>
                  <p className="corp-news-excerpt small text-muted mb-3">
                    Un accompagnement sur le digital et la logistique pour aider
                    les boutiques physiques à vendre en ligne facilement.
                  </p>
                  <Link to="/news" className="corp-news-link small">
                    Découvrir les histoires
                  </Link>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION “Notre raison d’être / Purpose” */}
      <section className="corp-section corp-purpose py-5">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-5">
              <h2 className="corp-section-title mb-3">
                Notre raison d’être
              </h2>
              <p className="text-muted">
                Nous voulons rendre les produits du quotidien plus accessibles,
                fiables et abordables, tout en créant des opportunités pour les
                vendeurs locaux et les jeunes marques africaines.
              </p>
              <p className="text-muted mb-3">
                GoShop est construit autour de trois piliers : la confiance,
                la transparence et la simplicité.
              </p>
            </div>
            <div className="col-lg-7">
              <div className="row g-3 g-md-4">
                <div className="col-sm-6">
                  <div className="corp-pill card h-100 border-0">
                    <div className="card-body">
                      <h3 className="h6 mb-2">Offrir plus de valeur</h3>
                      <p className="small text-muted mb-0">
                        Prix clairs, promotions pertinentes et sélection
                        inspirée des meilleurs produits américains & locaux.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="corp-pill card h-100 border-0">
                    <div className="card-body">
                      <h3 className="h6 mb-2">Servir nos vendeurs</h3>
                      <p className="small text-muted mb-0">
                        Outils de gestion, visibilité sur la page d’accueil
                        et solutions de livraison intégrées.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="corp-pill card h-100 border-0">
                    <div className="card-body">
                      <h3 className="h6 mb-2">Investir dans la logistique</h3>
                      <p className="small text-muted mb-0">
                        Suivi des colis, réseaux de points relais et
                        partenariats avec des transporteurs fiables.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="corp-pill card h-100 border-0">
                    <div className="card-body">
                      <h3 className="h6 mb-2">Impact & communauté</h3>
                      <p className="small text-muted mb-0">
                        Création d’emplois, soutien aux TPE, et projets
                        sociaux portés avec nos partenaires (associations,
                        ONG, fondations…).
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION “Chiffres clés / Stats” */}
      <section className="corp-section py-5">
        <div className="container">
          <h2 className="corp-section-title mb-4">GoShop en quelques chiffres</h2>
          <div className="row g-3 g-md-4">
            <div className="col-6 col-md-3">
              <div className="corp-stat card border-0 h-100">
                <div className="card-body text-center">
                  <div className="corp-stat-value">+{">"}200</div>
                  <div className="corp-stat-label small text-muted">
                    vendeurs actifs
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="corp-stat card border-0 h-100">
                <div className="card-body text-center">
                  <div className="corp-stat-value">+{">"}5 000</div>
                  <div className="corp-stat-label small text-muted">
                    références produits
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="corp-stat card border-0 h-100">
                <div className="card-body text-center">
                  <div className="corp-stat-value">+{">"}10</div>
                  <div className="corp-stat-label small text-muted">
                    villes livrées
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="corp-stat card border-0 h-100">
                <div className="card-body text-center">
                  <div className="corp-stat-value">24/7</div>
                  <div className="corp-stat-label small text-muted">
                    commande possible par WhatsApp
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION CTA double (Carrières / Devenir vendeur) */}
      <section className="corp-section corp-cta-strip py-5">
        <div className="container">
          <div className="row g-3 g-md-4">
            <div className="col-md-6">
              <div className="corp-cta-card card border-0 h-100">
                <div className="card-body d-flex flex-column">
                  <h3 className="h5 mb-2">Carrières & équipe</h3>
                  <p className="small text-muted flex-grow-1">
                    Rejoins une équipe passionnée par l’e-commerce,
                    la logistique et la tech en Afrique de l’Ouest.
                  </p>
                  <a
                    href="mailto:recrutement@goshopforall.com"
                    className="btn btn-primary btn-sm align-self-start"
                  >
                    Envoyer une candidature
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="corp-cta-card card border-0 h-100">
                <div className="card-body d-flex flex-column">
                  <h3 className="h5 mb-2">Devenir vendeur GoShop</h3>
                  <p className="small text-muted flex-grow-1">
                    Tu as une boutique physique ou une marque&nbsp;?
                    Nous t’aidons à vendre en ligne, gérer tes stocks
                    et livrer tes clients.
                  </p>
                  <Link
                    to="/vendor/products"
                    className="btn btn-outline-primary btn-sm align-self-start"
                  >
                    Voir les solutions vendeurs
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
